
import { defineComponent, ref } from 'vue'
import {
  IonContent,
  IonText,
  IonImg,
  IonItem,
  IonLabel,
  IonSelect,
  IonSelectOption,
  IonButton,
  IonModal,
  IonInput,
  IonBadge,
  IonIcon,
  IonToolbar,
} from '@modus/ionic-vue'
import { useRoute, useRouter } from 'vue-router'
import { useProduct } from '@/composables/products'
import cart from '@/composables/cart'
import CartComponent from '@/components/CartComponent.vue'
import useCategories from '@/composables/categories'
import { close, checkbox } from 'ionicons/icons'
import { addIcons } from 'ionicons'

addIcons({ close, checkbox })

export default defineComponent({
  name: 'ProductDetails',
  components: {
    IonContent,
    IonText,
    IonImg,
    IonItem,
    IonLabel,
    IonSelect,
    IonSelectOption,
    IonButton,
    IonModal,
    IonInput,
    CartComponent,
    IonBadge,
    IonIcon,
    IonToolbar,
  },

  async setup() {
    const { params } = useRoute()
    const { push } = useRouter()
    const { product } = await useProduct(params.productId as string)
    const isOpen = ref(false)
    const currency = cart.getCurrencyFormat()
    const quantity = ref(1)
    const defaultVariant = product.value.variants[0] || ''
    const variant = ref(defaultVariant)
    const { getCategoryById } = await useCategories()
    const category = ref(getCategoryById(product.value.category))

    const uniqueVariants = Array.from(
      new Map(
        product.value.variants.map((variant) => [variant['title'], variant])
      ).values()
    )

    function setQuantity(num: number) {
      quantity.value = num
    }

    function setVariant(e: Event) {
      const target = e.target as HTMLSelectElement
      const selected = target?.value
      variant.value = selected
        ? uniqueVariants.find(
            (variant) => variant.title === selected.valueOf()
          ) || defaultVariant
        : defaultVariant
    }

    function addToCart() {
      isOpen.value = true
      cart.add(product.value, variant.value, quantity.value)
    }

    function willDismiss() {
      isOpen.value = false
    }

    function toCheckout() {
      push('/checkout')
    }

    return {
      product,
      currency,
      isOpen,
      cart,
      addToCart,
      willDismiss,
      setQuantity,
      setVariant,
      quantity,
      variant,
      uniqueVariants,
      category,
      toCheckout,
    }
  },
})
